<template>
  <ModalAddEditCoupon
    ref="modal"
    v-if="modalShowAddCoupon"
    @closeModal="modalCloseAddCoupon"
    :couponData="couponToEdit"
  />
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      text="Are you sure you want to delete this Coupon?"
      text_class="text-xl font-medium"
      title="Delete Coupon"
    />
  </transition>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-96 h-fit">
    <PageHeader
      class="col-span-2 sm:col-span-1 lg:col-span-2"
      title="Coupon"
      subtitle="Our Latest Coupon"
    ></PageHeader>
    <div
      class="col-span-2 sm:col-span-1 lg:col-span-2 flex justify-end items-end"
    >
      <Button
        button_id="new-coupon"
        button_text="&#43; New Coupon"
        @click="showModalAddEditCoupon"
      />
    </div>
    <Card card_class="col-span-2 lg:col-span-4">
      <DinamicTable :header_columns="table_header">
        <TableRow v-for="(coupon, index) in filteredCoupon" :key="index">
          <TableCell>{{ index + 1 }}</TableCell>
          <TableCell>{{ coupon?.name }}</TableCell>
          <TableCell>{{ coupon?.max_usage }}</TableCell>
          <TableCell>
            {{
              coupon?.expiry_period_per_branch
                ? coupon?.expiry_period_per_branch[0]?.expire_days + " Days"
                : ""
            }}
            <!-- <template v-if="coupon.expiry_period_per_branch">
              <span v-for="(expiry_period, index) in coupon?.expiry_period_per_branch" :key="index" class="block">
                {{ expiry_period.branch_name }} : {{ expiry_period.expire_days }} Days
              </span>
            </template> -->
          </TableCell>
          <TableCell>{{
            coupon?.on_percentage
              ? coupon?.discount + "%"
              : formatRupiah(coupon?.discount)
          }}</TableCell>
          <TableCell>
            <div class="flex items-center gap-2">
              <TableButtonEdit
                path="#"
                :container_id="`btnEditCoupon${coupon?.id}`"
                @click="editCoupon(coupon)"
              />
              <TableButtonDelete
                @click="deleteCoupon(coupon?.id)"
                path="#"
                :container_id="`btnDeleteCoupon${coupon?.id}`"
              />
            </div>
          </TableCell>
        </TableRow>
      </DinamicTable>
    </Card>
  </section>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import TableButtonEdit from "@/components/atoms/table/TableButtonEdit.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import ModalAddEditCoupon from "@/components/modals/ModalAddEditCoupon.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import Button from "@/components/buttons/Button.vue";
import { mapGetters, mapActions } from "vuex";
import { formatRupiah } from "@/helpers/formating";

export default {
  name: "Coupon",
  components: {
    PageHeader,
    DinamicTable,
    Card,
    TableButtonEdit,
    TableButtonDelete,
    AlertConfirmation,
    ModalAddEditCoupon,
    TableRow,
    TableCell,
    Button,
  },
  data() {
    return {
      table_header: [
        "No",
        "Coupon Name",
        "Max Usage",
        "Expiry Day Period",
        "Discount",
        "Action",
      ],
      alert_confirmation: false,
      animation_alert_confirmation_class: "",
      modalShowAddCoupon: false,
      couponIdToDelete: null,
      couponToEdit: null,
    };
  },
  created() {
    this.$store.dispatch("coupons/fetchCoupons");
  },
  computed: {
    ...mapGetters("coupons", ["allCoupon", "pagination"]),

    filteredCoupon() {
      return this.allCoupon;
    },
  },
  methods: {
    formatRupiah,
    ...mapActions("coupons", ["fetchCoupons", "deleteCouponById"]),

    async fetchCoupons(page = 1, limit = 15) {
      const params = {
        page,
        limit,
      };
      await this.$store.dispatch("coupons/fetchCoupons", params);
    },

    handle_clicked_no() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.couponIdToDelete = null;
    },
    handle_clicked_yes() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.deleteCouponById(this.couponIdToDelete);
      this.fetchCoupons(1);
      this.couponIdToDelete = null;
    },
    showModalAddEditCoupon() {
      this.couponToEdit = null;
      this.modalShowAddCoupon = true;
    },
    modalCloseAddCoupon() {
      this.modalShowAddCoupon = false;
      this.fetchCoupons(1);
    },
    deleteCoupon(id) {
      this.couponIdToDelete = id;
      this.alert_confirmation = true;
    },
    editCoupon(coupon) {
      this.couponToEdit = coupon;
      this.modalShowAddCoupon = true;
    },
  },
};
</script>
